export function MenuDivider() {
  return <li className="dropdown-divider"></li>
}
